/*
 * Filtros da vitrine no celular.
 *
 * O HTML entrega tudo ABERTO de propósito: o bloco e os sete grupos nascem
 * com `open`. Sem este arquivo a página é a de sempre, coluna de filtro
 * inteira na tela, funcionando por <form method="get">. Nenhum filtro depende
 * de JavaScript para filtrar.
 *
 * O que este arquivo faz é uma coisa só: FECHAR o que não cabe no celular.
 * Abaixo de 990px o bloco vira botão e cada grupo vira sanfona; de 990px para
 * cima tudo volta a ficar aberto. O ponto de virada é o mesmo do CSS, e os
 * dois têm de continuar iguais.
 *
 * O bloco abre na própria página, empurrando a grade para baixo. Não cobre a
 * vitrine, então não há trava de rolagem, foco preso nem tecla Esc para sair:
 * o mesmo botão que abriu fecha. Painel de tela cheia foi tentado em
 * 12/09/2026 e reprovado no mesmo dia, porque sumia com os produtos.
 *
 * Grupo com valor marcado (`data-filtro-ligado`) continua aberto mesmo no
 * celular: esconder o que a pessoa acabou de escolher é pior do que a rolagem.
 *
 * A segunda tarefa é o "Ordenar por". Sem script ele é um formulário com
 * botão Aplicar dentro de <noscript>; com script o botão some, então alguém
 * tem de enviar a escolha. Até 12/09/2026 ninguém enviava: trocar a ordem não
 * fazia nada. A ordenação não depende de haver filtro na coleção, por isso
 * roda antes da saída antecipada logo abaixo.
 *
 * Nenhuma string de interface aqui: o que é texto vive em locales/.
 */
(function () {
  'use strict';

  /* Monta o endereço a partir do atual, e não do <form>: o formulário de
     ordenação não carrega os filtros marcados, e enviar ele apagaria todos.
     A página volta para a 1, porque a 3 de outra ordem é outra lista. */
  var ordenacao = document.querySelector('[data-select-ordenacao]');
  if (ordenacao !== null) {
    ordenacao.addEventListener('change', function () {
      var endereco = new URL(window.location.href);
      endereco.searchParams.set('sort_by', ordenacao.value);
      endereco.searchParams.delete('page');
      window.location.assign(endereco.toString());
    });
  }

  var caixa = document.querySelector('[data-filtros]');
  if (caixa === null) return;

  var grupos = caixa.querySelectorAll('[data-filtro-grupo]');

  /* Mesmo ponto de virada do @media (max-width: 989px) do CSS. */
  var telaLarga = window.matchMedia('(min-width: 990px)');

  /* Guarda o estado anterior para não fechar na cara de quem abriu: o ajuste
     só roda quando a tela REALMENTE troca de faixa. */
  var eraCelular = null;

  function ajustar() {
    var celular = telaLarga.matches === false;
    if (celular === eraCelular) return;
    eraCelular = celular;

    caixa.open = celular === false;

    Array.prototype.forEach.call(grupos, function (grupo) {
      grupo.open = celular === false || grupo.hasAttribute('data-filtro-ligado');
    });
  }

  /* addListener é o nome antigo; Safari só ganhou addEventListener em 14. */
  if (typeof telaLarga.addEventListener === 'function') {
    telaLarga.addEventListener('change', ajustar);
  } else {
    telaLarga.addListener(ajustar);
  }

  ajustar();
})();
